import { useState } from "react";
import { Button } from "@material-ui/core";
import { DeleteSweepOutlined } from "@material-ui/icons";
import {
  useCancelBookingButtonsGroupLazyQuery,
  useCancelBookingGroupMutation
} from "@bonliva-crm/graphql";
import locale from "@bonliva-crm/locale";
import { useSnackbarsPipeline } from "@bonliva-crm/ui";
import { CancelBookingDialog } from "../../CancelBookingDialog/CancelBookingDialog";
import { themeObject } from "@theme";

type Props = {
  bookingId: string;
};

export function CancelBookingGroupButton(props: Props) {
  const snack = useSnackbarsPipeline();
  const [showCancelDialog, setShowCancelDialog] = useState(false);

  const [checkCancellable, { data, loading: checkLoading }] =
    useCancelBookingButtonsGroupLazyQuery();

  const [cancelBookingGroup, { loading: mutationLoading }] =
    useCancelBookingGroupMutation({
      onCompleted: () => {
        snack.showSuccess(locale["Booking has been canceled"]);
        setShowCancelDialog(false);
      },
      onError: (e) => {
        snack.showError(e.message, "Cannot cancel booking");
        setShowCancelDialog(false);
      }
    });

  const handleClick = () => {
    setShowCancelDialog(true);
    checkCancellable({
      variables: { bookingId: props.bookingId },
      fetchPolicy: "network-only"
    });
  };

  const blockReasons: string[] = [];
  if (data && !data.checkBookingGroupCancellableByBookingId.isCancellable) {
    const nonCancellableReason =
      data.checkBookingGroupCancellableByBookingId.nonCancellableReason;
    if (nonCancellableReason) {
      nonCancellableReason.split("\n").forEach((line) => {
        if (line.trim()) blockReasons.push(line.trim());
      });
    }
  }

  const isCheckLoading = checkLoading || (showCancelDialog && !data);

  return (
    <>
      <Button
        variant="text"
        onClick={handleClick}
        style={{ color: themeObject.palette.error.main }}
      >
        <DeleteSweepOutlined />
        {locale.CancelAllWeeks}
      </Button>

      <CancelBookingDialog
        open={showCancelDialog}
        title={locale["Are you sure you want to cancel booking group?"]}
        loading={mutationLoading}
        checkLoading={isCheckLoading}
        blockReasons={blockReasons.length > 0 ? blockReasons : undefined}
        onCancel={(reason) => {
          cancelBookingGroup({
            variables: {
              id: data?.bookingById.BookingGroup._id,
              reason
            }
          });
        }}
        onClose={() => {
          setShowCancelDialog(false);
        }}
      />
    </>
  );
}
